import { useEffect, useState } from 'react';

export default function HTMLRenderer({ htmlcode, setEditorValue,disabled }) {
    const [htmlInput, setHtmlInput] = useState('');

    useEffect(() => {
        setHtmlInput(htmlcode)
    }, [htmlcode])

    const handleInputChange = (e) => {
        setHtmlInput(e.target.value);
        setEditorValue(e.target.value)
    };

    const renderHTML = () => {
        try {
            return { __html: htmlInput };
        } catch (err) {
            return { __html: "" };
        }
    };

    return (
        <div className="w-full max-w-4xl mx-auto">

            <div className="mb-4">
                <textarea
                    id="htmlInput"
                    style={{ width: "100%", minHeight: "200px" }}
                    value={htmlInput}
                    onChange={handleInputChange}
                    className="w-full h-64 p-2 border border-gray-300 rounded font-mono text-sm"
                    spellCheck="false"
                    disabled={disabled}
                />
            </div>


            <div className="border border-gray-300 rounded mb-4">
                <div className="p-4 bg-white rounded">
                    <div dangerouslySetInnerHTML={renderHTML()} />
                </div>
            </div>

        </div>
    );
}